import { render, staticRenderFns } from "./FB_Messenger.vue?vue&type=template&id=69166a44"
import script from "./FB_Messenger.vue?vue&type=script&lang=js"
export * from "./FB_Messenger.vue?vue&type=script&lang=js"
import style0 from "./FB_Messenger.vue?vue&type=style&index=0&id=69166a44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports